import { Box, Button, ButtonGroup, Card, CardMedia, Typography } from '@mui/material';
import React from 'react';
import { COLOR_PRIMARY_2 } from 'src/colors';
import { PAYMENT_MODAL_GREEN, PAYMENT_MODAL_GREEN_HOVER } from 'src/const';

const CustomJoyrideTooltip = ({
  index,
  totalSteps,
  onNext,
  onBack,
  content,
  title = '',
  image = '',
  tutorial = '',
}) => {
  const openTutorial = () => {
    window.open(tutorial, '_blank');
  };
  const handleNext = () => {
    onNext();
  };

  const handleBack = () => {
    onBack();
  };

  const buttonStyle: any = {
    background: '#fff',
    borderRadius: 200,
    color: COLOR_PRIMARY_2,
    border: 'none !important',
    textTransformation: 'capitalize',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: PAYMENT_MODAL_GREEN_HOVER,
      color: '#fff',
    },
  };
  return (
    <Box>
      {title && <Typography variant="body1"> {title} </Typography>}
      {image && (
        <Card>
          <CardMedia component="img" alt="GIF" src={image} style={{ height: '150px' }} />
        </Card>
      )}
      {content && (
        <Typography variant="body2" sx={{ paddingBottom: 2, textAlign: 'left', paddingTop: 1 }}>
          {' '}
          {content}
        </Typography>
      )}

      {tutorial && (
        <ButtonGroup variant="outlined" size="small" sx={{ borderRadius: 2, float: 'left' }}>
          <Button
            size="small"
            sx={{ ...buttonStyle, borderLeft: '1px solid black' }}
            onClick={openTutorial}
          >
            Tutorial
          </Button>
        </ButtonGroup>
      )}

      <ButtonGroup variant="outlined" size="small" sx={{ borderRadius: 2, float: 'right' }}>
        <Button size="small" sx={{ ...buttonStyle }} disabled={index === 0} onClick={handleBack}>
          Back
        </Button>
        <Button
          size="small"
          sx={{ ...buttonStyle, borderLeft: '1px solid black' }}
          disabled={index === totalSteps}
          onClick={handleNext}
        >
          {index === totalSteps - 1 ? 'Finish' : 'Next'}
        </Button>
      </ButtonGroup>
    </Box>
  );
};

export default CustomJoyrideTooltip;
